import * as Yup from 'yup';

const required = "requerido";
const url = "debe ser un URL válido";

export const SectionSchema = Yup.object().shape({
  title: Yup.string().required('requerido'),
  identifier: Yup.string().required('requerido').matches(/^[a-zA-Z0-9-]*$/, "formato inválido").nullable(),
});

export const SellerApplicationFormSchema = Yup.object().shape({
  first_name: Yup.string().required(required),
  last_name: Yup.string().required(required),
  email: Yup.string().email().required(required),
  phone: Yup.string().required(required),
  
  company_name: Yup.string().required(required),
  legal_id: Yup.number().typeError('debe ser un número sin guiones').required(required),
  // bank_account_number: Yup.string().required(required),
  address: Yup.string().required(required),

  commerce_information: Yup.string().required(required),
  website: Yup.string().url(url).nullable(),
});

export const SellerApplicationFormUpdateSchema = Yup.object().shape({
  bank_account_number: Yup.string().nullable(),
  currency: Yup.string().required(required),
  company_name: Yup.string().required(required),
});

export const BlankSchema = Yup.object().shape({});